import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/styles/iconfont.js'
import '@/assets/styles/global.scss'
import IconFont from '@/components/IconFont.vue'
import { initPoints } from '@/utils/points'
import { initAuth, getToken } from '@/utils/auth'
import { fetchAndRefreshUser } from '@/utils/userSession'

Vue.component('IconFont', IconFont)

Vue.config.productionTip = false
initPoints()
initAuth()
if (getToken()) {
  fetchAndRefreshUser()
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
